<div soho-tabs>
    <div soho-tab-list-container>
        <ul soho-tab-list>
            <li soho-tab>
                <a soho-tab-title tabId="tabs-setting-visual" data-automation-id="lm-settings-dialog-visual-tab">{{'Visual' | translate}}</a>
            </li>
            <li soho-tab>
                <a soho-tab-title tabId="tabs-setting-functional" data-automation-id="lm-settings-dialog-functional-tab">{{'Functional' | translate}}</a>
            </li>
            <li soho-tab>
                <a soho-tab-title tabId="tabs-setting-productivity" data-automation-id="lm-settings-dialog-productivity-tab">{{'Productivity' | translate}}</a>
            </li>
        </ul>
    </div>
    <div soho-tab-panel-container style="min-height: 200px; width: 400px; margin-top: 13px">
        <div soho-tab-panel tabId="tabs-setting-visual">
            <div class="row lm-inner-space" soho-personalize>
                <!-- THEME FIELD -->
                <div class="field" *ngIf="!usingPortalTheme">
                    <label for="theme" class="label">{{'Theme' | translate}}</label>
                    <select soho-dropdown
                        noSearch
                        id="theme"
                        attr.data-automation-id="{{themeSelectAttributes[0].value + '-select'}}"
                        [attributes]="themeSelectAttributes"
                        name="theme"
                        [(ngModel)]="settings.theme"
                        (change)="theme($event)"
                    >
                        <ng-container *ngFor="let theme of availableThemes">
                            <option value={{theme.id}} [selected]="theme.id === settings.theme">
                                {{theme.name | translate}}
                            </option>
                        </ng-container>
                    </select>
                </div>

                <!-- THEME COLOR FIELD -->
                <div class="field" *ngIf="!usingPortalColor">
                    <label for="colors" class="label">{{ 'Colors' | translate }}</label>
                    <select soho-dropdown
                        noSearch
                        id="colors"
                        name="colors"
                        attr.data-automation-id="{{colorSelectAttributes[0].value + '-select'}}"
                        [attributes]="colorSelectAttributes"
                        [(ngModel)]="settings.color"
                        (change)="color($event)"
                    >
                        <ng-container *ngFor="let color of themeColors | keys">
                            <option
                                value="{{color.value.id}}"
                                [attr.data-hex]="color.value.value"
                                [selected]="color.value.id === settings.color"
                                [attr.data-icon]="JSON.stringify({ icon: 'swatch', class: color.value.backgroundColorClass + ' swatch'})"
                            >
                                {{color.value.name}}
                            </option>
                        </ng-container>
                    </select>
                </div>

                <div class="field switch">
                    <input
                        type="checkbox"
                        id="use-compact-layout"
                        data-automation-id="lm-settings-dialog-use-compact-layout"
                        name="use-compact-layout"
                        [(ngModel)]="settings.useCompactFormLayout"
                    >
                    <label for="use-compact-layout">{{ 'UseCompactLayout' | translate }}</label>
                </div>

                <div class="field switch">
                    <input
                        type="checkbox"
                        id="accessibility-mode"
                        data-automation-id="lm-settings-dialog-accessibility-mode"
                        name="accessibility-mode"
                        [(ngModel)]="settings.accessibilityMode"
                    >
                    <label for="accessibility-mode">{{ 'AccessibilityMode' | translate }}</label>
                </div>

                <!-- PREFERRED APPLICATION FIELD -->
                <div class="field" *ngIf="displayPreferredApplication">
                    <label for="preferredApp" class="label">{{ 'PreferredApplication' | translate }}</label>
                    <select soho-dropdown noSearch id="preferredApp" name="preferredApp" [(ngModel)]="settings.preferredWebApp" (change)="preferredApp($event)" [attributes]="preferredAppAttributes">
                        <option value="" soho-title title="{{ 'NoPreferred' | translate }}">{{ 'NoPreferred' | translate }}</option>
                        <option *ngFor="let app of availableApps" value={{app.webAppName}} soho-title title="{{app.webAppTitle}}" [selected]="app.webAppName === settings.preferredWebApp">{{app.webAppTitle}}</option>
                    </select>
                </div>
            </div>
        </div>

        <div soho-tab-panel tabId="tabs-setting-functional">
            <div class="row lm-inner-space" soho-personalize>
                <h2 class="fieldset-title">{{ 'PDFCSV' | translate }}</h2>
                <div class="field">
                    <label for="maxWaitTimePDFCSV" class="label">{{ 'MaxWaitTimePDFCSV' | translate }}</label>
                    <select soho-dropdown noSearch id="maxWaitTimePDFCSV" name="maxWaitTimePDFCSV" attr.data-automation-id="{{maxWaitTimePDFSelectAttributes[0].value + '-select'}}" [attributes]="maxWaitTimePDFSelectAttributes" [(ngModel)]="settings.maxWaitPDFCSV" (change)="setMaxWaitPDFCSV($event)">
                        <option value="0">{{ 'NeverWait' | translate }}</option>
                        <option value="5">{{ 'FiveS' | translate }}</option>
                        <option value="10">{{ 'TenS' | translate }}</option>
                        <option value="15">{{ 'FifteenS' | translate }}</option>
                    </select>
                </div>
                <div class="field">
                    <label for="export-record-limit-default" class="label">{{ 'ExportRecordLimitDefault' | translate }}</label>
                    <select soho-dropdown noSearch id="export-record-limit-default" name="exportRecordLimitDefault" data-automation-id="lm-settings-dialog-export-record-limit-default" attr.data-automation-id="{{exportRecordLimitDefaultAttributes[0].value + '-select'}}" [attributes]="exportRecordLimitDefaultAttributes" [(ngModel)]="settings.exportDefaultRecordLimit">
                        <option value="system">{{ 'ExportRecordLimitDefaultSystemOption' | translate }}</option>
                        <option value="no-limit">{{ 'ExportRecordLimitDefaultNoLimitOption' | translate }}</option>
                    </select>
                </div>
                <hr *ngIf="showDeletedRecordEnabled || showArchiveEnabled || displayAllowSetAsOfDate">
                <div class="field switch" *ngIf="showDeletedRecordEnabled" style="margin-top: 10px">
                    <input
                        type="checkbox"
                        id="show-deleted-records"
                        name="show-deleted-records"
                        data-automation-id="lm-settings-dialog-show-deleted-records"
                        [(ngModel)]="showDeletedRecords">
                    <label for="show-deleted-records">{{ 'ShowDeleteRecordsSetting' | translate }}</label>
                </div>
                <div class="field switch" *ngIf="showArchiveEnabled" style="margin-top: 10px">
                    <input
                            type="checkbox"
                            id="show-view-archive"
                            name="show-view-archive"
                            data-automation-id="lm-settings-dialog-view-archive"
                            [(ngModel)]="settings.archiveMode">
                    <label for="show-view-archive">{{ 'ArchiveMode' | translate }}</label>
                </div>
                <div *ngIf="displayAllowSetAsOfDate" class="field" style="margin-top: 10px" data-automation-id="lm-settings-dialog-as-of-date-container">
                    <label for="as-of-date" class="label">{{ 'CreateReportAsOfDateLabel' | translate }}</label>
                    <input
                        id="as-of-date"
                        name="date"
                        soho-datepicker [options]="pickerOptions"
                        [(ngModel)]="settings.asOfDate"
                        (change)="changeAsOfDate($event)"
                        attr.aria-label="{{ 'AsOfDateLabel' | translate }}"
                        data-validate="invalidDate"
                        data-automation-id="lm-settings-dialog-as-of-date"
                    />
                    <div id="asofdate-error" *ngIf="showAsOfDateError" class="error-message" data-automation-id="lm-settings-dialog-as-of-date-alert">
                        <svg class="icon-error icon" focusable="false" aria-hidden="true" role="presentation">
                            <use href="#icon-error"></use>
                        </svg>
                        <pre class="audible">Error</pre>
                        <p class="message-text">{{'AsOfDateValidationMessage' | translate}}</p>
                    </div>
                </div>
            </div>
        </div>

        <div soho-tab-panel tabId="tabs-setting-productivity">
            <div class="row lm-inner-space" soho-personalize>
                <h2 class="fieldset-title">{{ 'ToastMessage' | translate }}</h2>
                <!-- Toast message position -->
                <div class="field">
                    <label for="toastMessagePosition" class="label">{{ 'ToastMessagePosition' | translate }}</label>
                    <select soho-dropdown
                        noSearch
                        id="toastMessagePosition"
                        attr.data-automation-id="{{toastMessagePositionSelectAttributes[0].value + '-select'}}"
                        [attributes]="toastMessagePositionSelectAttributes"
                        name="toastMessagePosition"
                        [(ngModel)]="settings.toastMessagePosition"
                        (change)="toastMessagePosition($event)"
                    >
                        <option value="BLANK" *ngIf="toastMessageHasCustomPosition"></option>
                        <option value="DEFAULT">{{ 'Default' | translate }}</option>
                        <option value="TOP_LEFT">{{ 'TopLeft' | translate }}</option>
                        <option value="TOP_RIGHT">{{ 'TopRight' | translate }}</option>
                        <option value="BOTTOM_LEFT">{{ 'BottomLeft' | translate }}</option>
                        <option value="BOTTOM_RIGHT">{{ 'BottomRight' | translate }}</option>
                    </select>
                </div>
                <!-- Toast message duration -->
                <div class="field">
                    <label for="toastMessageDuration" class="label">{{ 'ToastMessageDuration' | translate }}</label>
                    <select soho-dropdown
                        noSearch
                        id="toastMessageDuration"
                        attr.data-automation-id="{{toastMessageDurationSelectAttributes[0].value + '-select'}}"
                        [attributes]="toastMessageDurationSelectAttributes"
                        name="toastMessageDuration"
                        [(ngModel)]="settings.toastMessageDuration"
                        (change)="toastMessageDuration($event)">
                        <option value="BLANK"></option>
                        <option value="SHORTER">{{ 'Shorter' | translate }}</option>
                        <option value="DEFAULT">{{ 'Default' | translate }}</option>
                        <option value="LONGER">{{ 'Longer' | translate }}</option>
                    </select>
                </div>
                <hr>
                <!-- Automatic Searching -->
                <div class="field" style="margin-top: 10px">
                    <label for="filterBarMode" class="label">{{ 'SearchMode' | translate }}</label>
                    <select soho-dropdown noSearch id="filterBarMode" name="filterBarMode" attr.data-automation-id="{{searchModeSelectAttributes[0].value + '-select'}}" [attributes]="searchModeSelectAttributes" [(ngModel)]="settings.automaticSearch" (change)="setFilterBarMode($event)">
                        <option value="active">{{ 'Active' | translate }}</option>
                        <option value="passive">{{ 'Passive' | translate }}</option>
                    </select>
                </div>
            </div>
        </div>
        <!-- KEYBOARD SHORTCUTS -->
        <div class="field" *ngIf="displayShortcuts">
            <a soho-hyperlink (click)="openKeyboardShortcutsDialog()" data-automation-id="lm-settings-dialog-keyboard-shortcuts">{{ 'KeyboardShortcuts' | translate }}</a>
        </div>
    </div>
</div>
<div #keyboardDialogPlaceholder id="keyboardDialogPlaceholder" class="lmDialogPlaceholder"></div>
